import { useMerchantQry, useUserProfileQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'

export const WelcomeTitle = () => {
  const { merchant, merchantLoading } = useMerchantQry()
  const { profile, profileLoading } = useUserProfileQry()

  if (merchantLoading || profileLoading) {
    return null
  }

  // Under a sub-merchant the greeting follows the active company; otherwise it is the logged-in user.
  const isSubMerchant = Boolean(merchant?.parentMerchantId)
  const name = (isSubMerchant && merchant?.name) || profile?.firstName

  return (
    <span className='title'>
      {name
        ? tr('FRONTEND.HEADER.WELCOME', 'Hello, {{name}}!', { name })
        : tr('FRONTEND.HEADER.WELCOME_NO_NAME', 'Hello!')}
    </span>
  )
}
